import React,{useEffect} from "react";
import { useParams, Link } from 'react-router-dom';
import { motion } from "framer-motion";
import { Clock3, ListChecks, ChefHat } from 'lucide-react';
import styles from './RecipeDetailPage.module.css';
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import Chatbot from "../components/Chatbot";
import AiIcon from "../components/AiIcon";
import recipesData from "../data/Recipes";
import axios from "axios";
import { getRecipeDetailApi, getRecipesApi } from "../http/api";
import Loader from "../components/Loader";
import { useSelector } from "react-redux";
import { useTranslate } from "../components/UseTranslate";

export function RecipeDetailPage() {
  const { recipeId } = useParams();

  console.log(recipeId,"recipeId")
  const [chatOpen, setChatOpen] = React.useState(false);

  const [loading,setLoading] = React.useState(true);

  const [recipe, setRecipe] = React.useState(null);
  const [relatedRecipes, setRelatedRecipes] = React.useState([]);

  const {language} = useSelector((state) => state.language);
  const {t} = useTranslate();


  const fetchRecipeData = async() => {
    setLoading(true);
    try{
      const response = await axios.get(getRecipeDetailApi(recipeId,language));
      const foundRecipe = response?.data?.recipe;
      setRecipe(foundRecipe);
      const cat_id = response?.data?.recipe?.category_id;
      const recipesResponse = await axios.get(getRecipesApi(cat_id,language));
      setRelatedRecipes(recipesResponse?.data?.recipes);
      setLoading(false)
    }
    catch(err){
      console.log(err);
    }
    finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    fetchRecipeData()

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  },[recipeId,language])


  if(loading){
    return (
      <>
      <Loader/>
      </>
    )
  }



  if (!recipe) {
    return (
      <div className={styles.notFoundContainer}>
        <div className={styles.notFoundContent}>
          <h1 className={styles.notFoundTitle}>Recipe Not Found</h1>
          <Link to="/" className={styles.notFoundLink}>Go back home</Link>
        </div>
      </div>
    );
  }

  

  return (
    <div className={styles.container}>
      <Header />
      <div>
        <AiIcon onClick={() => setChatOpen(true)} />
        <Chatbot
          isOpen={chatOpen}
          onClose={() => setChatOpen(false)}
        />
      </div>

      {/* Recipe Hero */}
      <section className={styles.heroSection}>
        <motion.img
          initial={{ scale: 1.2 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.5 }}
          src={recipe.image_url}
          alt={recipe.name}
          className={styles.heroImage}
        />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContentWrapper}>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className={styles.heroContent}>
            <div className={styles.categoryLabels}>
              <motion.span className={styles.categoryBadge}>{recipe.category_name}</motion.span>
              <motion.span className={styles.categoryBadgeAlt}>
                <Clock3 className={styles.badgeIcon} />
                {recipe?.steps?.length} steps
              </motion.span>
            </div>
            <motion.h1 className={styles.heroTitle}>{recipe.recipe_name}</motion.h1>
            <p className={styles.heroSubtext}>
              {t('Easy to follow ingredients and cooking instructions.')}
            </p>
          </motion.div>
        </div>
      </section>

      <section className={styles.contentSection}>
        <div className={styles.contentWrapper}>
          <article className={styles.column}>
            <h2 className={styles.sectionTitle}>
              <ChefHat className={styles.sectionIcon} />
              {t('Ingredients')}
            </h2>
            <div className={styles.ingredientsGrid}>
              {recipe?.ingredients?.map((ing, i) => (
                <div key={`${recipe.id}-ing-${i}`} className={styles.ingredientChip}>
                  {ing.quantity} {ing.ingredient}
                </div>
              ))}
            </div>
          </article>

          <article className={styles.column}>
            <h2 className={styles.sectionTitle}>
              <ListChecks className={styles.sectionIcon} />
              {t('Instructions')}
            </h2>
            <ol className={styles.stepsList}>
              {recipe?.steps?.map((step, i) => (
                <li key={`${recipe.id}-step-${i}`} className={styles.stepItem}>
                  <span className={styles.stepNumber}>{step?.step_number}</span>
                  <p className={styles.stepText}>{step?.instruction}</p>
                </li>
              ))}
            </ol>
          </article>
        </div>
      </section>

      {relatedRecipes.length > 0 && (
        <section className={styles.relatedSection}>
          <h2 className={styles.relatedHeading}>More {recipe.category_name} </h2>
          <div className={styles.relatedGrid}>
            {relatedRecipes.sort(() => Math.random() - 0.5).slice(0,3).map((rel) => (
              <Link
                key={rel.id}
                to={`/recipe/${rel.id}`}
                className={styles.relatedCard}
              >
                <div className={styles.relatedImageWrapper}>
                  <img src={rel.image_url} alt={rel.recipe_name} className={styles.relatedImage} />
                </div>
                <p className={styles.relatedName}>{rel.recipe_name}</p>
              </Link>
            ))}
          </div>
        </section>
      )}
      <Footer />
    </div>
  );
}